(function () {
function $554ed4b40b13e16f$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $554ed4b40b13e16f$export$71511d61b312f219(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $554ed4b40b13e16f$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $554ed4b40b13e16f$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ function $0b5c99e6a0876eaa$export$71511d61b312f219(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}


var $fc5e3658b603cf39$var$extendStatics = function extendStatics1(d, b) {
    $fc5e3658b603cf39$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $fc5e3658b603cf39$var$extendStatics(d, b);
};
function $fc5e3658b603cf39$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $fc5e3658b603cf39$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $fc5e3658b603cf39$export$18ce0697a983be9b = function __assign1() {
    $fc5e3658b603cf39$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $fc5e3658b603cf39$export$18ce0697a983be9b.apply(this, arguments);
};
function $fc5e3658b603cf39$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $fc5e3658b603cf39$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $fc5e3658b603cf39$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $fc5e3658b603cf39$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $fc5e3658b603cf39$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $fc5e3658b603cf39$export$6a2a36740a146cb8(x) {
    return (typeof x === "undefined" ? "undefined" : (0, $0b5c99e6a0876eaa$export$71511d61b312f219)(x)) === "symbol" ? x : "".concat(x);
}
function $fc5e3658b603cf39$export$d1a06452d3489bc7(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $0b5c99e6a0876eaa$export$71511d61b312f219)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $fc5e3658b603cf39$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $fc5e3658b603cf39$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $fc5e3658b603cf39$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $fc5e3658b603cf39$export$45d3717a4c69092e = Object.create ? function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $fc5e3658b603cf39$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $fc5e3658b603cf39$export$45d3717a4c69092e(o, m, p);
}
function $fc5e3658b603cf39$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $fc5e3658b603cf39$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $fc5e3658b603cf39$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($fc5e3658b603cf39$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $fc5e3658b603cf39$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $fc5e3658b603cf39$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $fc5e3658b603cf39$export$10c90e4f7922046c(v) {
    return this instanceof $fc5e3658b603cf39$export$10c90e4f7922046c ? (this.v = v, this) : new $fc5e3658b603cf39$export$10c90e4f7922046c(v);
}
function $fc5e3658b603cf39$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $fc5e3658b603cf39$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $fc5e3658b603cf39$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $fc5e3658b603cf39$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $fc5e3658b603cf39$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $fc5e3658b603cf39$export$19a8beecd37a4c45 === "function" ? $fc5e3658b603cf39$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $fc5e3658b603cf39$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $fc5e3658b603cf39$var$__setModuleDefault = Object.create ? function __setModuleDefault(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $fc5e3658b603cf39$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $fc5e3658b603cf39$export$45d3717a4c69092e(result, mod, k);
    }
    $fc5e3658b603cf39$var$__setModuleDefault(result, mod);
    return result;
}
function $fc5e3658b603cf39$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $fc5e3658b603cf39$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $fc5e3658b603cf39$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $fc5e3658b603cf39$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $fc5e3658b603cf39$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $fc5e3658b603cf39$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function _SuppressedError(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $fc5e3658b603cf39$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $fc5e3658b603cf39$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $fc5e3658b603cf39$export$2e2bcd8739ae039 = {
    __extends: $fc5e3658b603cf39$export$a8ba968b8961cb8a,
    __assign: $fc5e3658b603cf39$export$18ce0697a983be9b,
    __rest: $fc5e3658b603cf39$export$3c9a16f847548506,
    __decorate: $fc5e3658b603cf39$export$29e00dfd3077644b,
    __param: $fc5e3658b603cf39$export$d5ad3fd78186038f,
    __metadata: $fc5e3658b603cf39$export$f1db080c865becb9,
    __awaiter: $fc5e3658b603cf39$export$1050f835b63b671e,
    __generator: $fc5e3658b603cf39$export$67ebef60e6f28a6,
    __createBinding: $fc5e3658b603cf39$export$45d3717a4c69092e,
    __exportStar: $fc5e3658b603cf39$export$f33643c0debef087,
    __values: $fc5e3658b603cf39$export$19a8beecd37a4c45,
    __read: $fc5e3658b603cf39$export$8d051b38c9118094,
    __spread: $fc5e3658b603cf39$export$afc72e2116322959,
    __spreadArrays: $fc5e3658b603cf39$export$6388937ca91ccae8,
    __spreadArray: $fc5e3658b603cf39$export$1216008129fb82ed,
    __await: $fc5e3658b603cf39$export$10c90e4f7922046c,
    __asyncGenerator: $fc5e3658b603cf39$export$e427f37a30a4de9b,
    __asyncDelegator: $fc5e3658b603cf39$export$bbd80228419bb833,
    __asyncValues: $fc5e3658b603cf39$export$e3b29a3d6162315f,
    __makeTemplateObject: $fc5e3658b603cf39$export$4fb47efe1390b86f,
    __importStar: $fc5e3658b603cf39$export$c21735bcef00d192,
    __importDefault: $fc5e3658b603cf39$export$da59b14a69baef04,
    __classPrivateFieldGet: $fc5e3658b603cf39$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $fc5e3658b603cf39$export$d40a35129aaff81f,
    __classPrivateFieldIn: $fc5e3658b603cf39$export$81fdc39f203e4e04,
    __addDisposableResource: $fc5e3658b603cf39$export$88ac25d8e944e405,
    __disposeResources: $fc5e3658b603cf39$export$8f076105dc360e92
};


"use strict";
var $3d28d7f1aac198f5$exports = {};
function $8713978b2328d32b$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $4fc75ccb937ab1df$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4fc75ccb937ab1df$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}


function $c3b10a83b523f372$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $c50969dc1df61e8b$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(arr);
}


function $09c9f293d010c0e1$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


function $38c2d4931cb7a7c4$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}



function $d4f69c5c6c4654b1$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
}


function $227c6742e0ff6f82$export$71511d61b312f219(arr) {
    return (0, $c50969dc1df61e8b$export$71511d61b312f219)(arr) || (0, $09c9f293d010c0e1$export$71511d61b312f219)(arr) || (0, $d4f69c5c6c4654b1$export$71511d61b312f219)(arr) || (0, $38c2d4931cb7a7c4$export$71511d61b312f219)();
}



"use strict";
var $3d28d7f1aac198f5$var$score = document.querySelector(".game-score");
var $3d28d7f1aac198f5$var$Game = /*#__PURE__*/ function() {
    function Game() {
        var board = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ]
        ], initialState = arguments.length > 1 ? arguments[1] : void 0;
        (0, $8713978b2328d32b$export$71511d61b312f219)(this, Game);
        this.board = board;
        this.initialState = initialState;
        this.score = 0;
        this.width = 4;
        this.squares = document.getElementsByClassName("field-cell");
        this.didMove = false;
    }
    (0, $4fc75ccb937ab1df$export$71511d61b312f219)(Game, [
        {
            key: "generate",
            value: function generate() {
                var firstValue = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
                var emptyExists = Array.from(this.squares).some(function(s) {
                    return s.innerHTML === "0";
                });
                if (!emptyExists || !this.didMove && !firstValue) return;
                var randomNumber = Math.floor(Math.random() * this.squares.length);
                if (this.squares[randomNumber].innerHTML === "0") {
                    var value = Math.random() < 0.1 ? 4 : 2;
                    this.squares[randomNumber].innerHTML = String(value);
                } else this.generate(firstValue);
            }
        },
        {
            key: "beforeStart",
            value: function beforeStart() {
                for(var i = 0; i < this.squares.length; i++)this.squares[i].innerHTML = 0;
                this.addColors();
            }
        },
        {
            key: "checkIfWin",
            value: function checkIfWin() {
                for(var i = 0; i < this.squares.length; i++)if (this.squares[i].innerHTML === "2048") {
                    this.initialState = "win";
                    document.removeEventListener("keydown", (0, $197cd56b15c33885$export$b5cde1de278b4330));
                    break;
                }
            }
        },
        {
            key: "checkIfLose",
            value: function checkIfLose() {
                for(var i = 0; i < 16; i++){
                    if (this.squares[i].innerHTML === "0") return;
                }
                for(var i1 = 0; i1 < 16; i1++)if (i1 % 4 !== 3) {
                    if (this.squares[i1].innerHTML === this.squares[i1 + 1].innerHTML) return;
                }
                for(var i2 = 0; i2 < 12; i2++){
                    if (this.squares[i2].innerHTML === this.squares[i2 + 4].innerHTML) return;
                }
                this.initialState = "lose";
                document.removeEventListener("keydown", (0, $197cd56b15c33885$export$b5cde1de278b4330));
            }
        },
        {
            key: "addColors",
            value: function addColors() {
                for(var i = 0; i < this.squares.length; i++){
                    this.squares[i].className = "field-cell";
                    if (this.squares[i].innerHTML === "0") {
                        this.squares[i].style.color = "#d6cdc4";
                        this.squares[i].style.backgroundColor = " #d6cdc4";
                    } else {
                        this.squares[i].classList.add("field-cell--".concat(this.squares[i].innerHTML));
                        this.squares[i].style.color = "";
                        this.squares[i].style.backgroundColor = "";
                    }
                }
            }
        },
        {
            key: "moveLeft",
            value: function moveLeft() {
                var _this = this, _loop = function(i) {
                    if (i % 4 === 0) {
                        var first = _this.squares[i].innerHTML;
                        var second = _this.squares[i + 1].innerHTML;
                        var third = _this.squares[i + 2].innerHTML;
                        var fourth = _this.squares[i + 3].innerHTML;
                        var row = [
                            parseInt(first),
                            parseInt(second),
                            parseInt(third),
                            parseInt(fourth)
                        ];
                        var filteredRow = row.filter(function(x) {
                            return x;
                        });
                        var missing = 4 - filteredRow.length;
                        var zeros = Array(missing).fill(0);
                        var newRow = filteredRow.concat(zeros);
                        if (!row.every(function(val, idx) {
                            return val === newRow[idx];
                        })) moved = true;
                        _this.squares[i].innerHTML = newRow[0];
                        _this.squares[i + 1].innerHTML = newRow[1];
                        _this.squares[i + 2].innerHTML = newRow[2];
                        _this.squares[i + 3].innerHTML = newRow[3];
                    }
                };
                var moved = false;
                for(var i = 0; i < 16; i++)_loop(i);
                this.didMove = moved;
            }
        },
        {
            key: "moveRight",
            value: function moveRight() {
                var _this = this, _loop = function(i) {
                    if (i % 4 === 0) {
                        var first = _this.squares[i].innerHTML;
                        var second = _this.squares[i + 1].innerHTML;
                        var third = _this.squares[i + 2].innerHTML;
                        var fourth = _this.squares[i + 3].innerHTML;
                        var row = [
                            parseInt(first),
                            parseInt(second),
                            parseInt(third),
                            parseInt(fourth)
                        ];
                        var filteredRow = row.filter(function(x) {
                            return x;
                        });
                        var missing = 4 - filteredRow.length;
                        var zeros = Array(missing).fill(0);
                        var newRow = zeros.concat(filteredRow);
                        if (!row.every(function(val, idx) {
                            return val === newRow[idx];
                        })) moved = true;
                        _this.squares[i].innerHTML = newRow[0];
                        _this.squares[i + 1].innerHTML = newRow[1];
                        _this.squares[i + 2].innerHTML = newRow[2];
                        _this.squares[i + 3].innerHTML = newRow[3];
                    }
                };
                var moved = false;
                for(var i = 0; i < 16; i++)_loop(i);
                this.didMove = moved;
            }
        },
        {
            key: "moveUp",
            value: function moveUp() {
                var _this = this, _loop = function(i) {
                    var first = _this.squares[i].innerHTML;
                    var second = _this.squares[i + _this.width].innerHTML;
                    var third = _this.squares[i + _this.width * 2].innerHTML;
                    var fourth = _this.squares[i + _this.width * 3].innerHTML;
                    var column = [
                        parseInt(first),
                        parseInt(second),
                        parseInt(third),
                        parseInt(fourth)
                    ];
                    var filteredColumn = column.filter(function(x) {
                        return x;
                    });
                    var missing = 4 - filteredColumn.length;
                    var zeros = Array(missing).fill(0);
                    var newColumn = filteredColumn.concat(zeros);
                    if (!column.every(function(val, idx) {
                        return val === newColumn[idx];
                    })) moved = true;
                    _this.squares[i].innerHTML = newColumn[0];
                    _this.squares[i + _this.width].innerHTML = newColumn[1];
                    _this.squares[i + _this.width * 2].innerHTML = newColumn[2];
                    _this.squares[i + _this.width * 3].innerHTML = newColumn[3];
                };
                var moved = false;
                for(var i = 0; i < 4; i++)_loop(i);
                this.didMove = moved;
            }
        },
        {
            key: "moveDown",
            value: function moveDown() {
                var _this = this, _loop = function(i) {
                    var first = _this.squares[i].innerHTML;
                    var second = _this.squares[i + _this.width].innerHTML;
                    var third = _this.squares[i + _this.width * 2].innerHTML;
                    var fourth = _this.squares[i + _this.width * 3].innerHTML;
                    var column = [
                        parseInt(first),
                        parseInt(second),
                        parseInt(third),
                        parseInt(fourth)
                    ];
                    var filteredColumn = column.filter(function(x) {
                        return x;
                    });
                    var missing = 4 - filteredColumn.length;
                    var zeros = Array(missing).fill(0);
                    var newColumn = zeros.concat(filteredColumn);
                    if (!column.every(function(val, idx) {
                        return val === newColumn[idx];
                    })) moved = true;
                    _this.squares[i].innerHTML = newColumn[0];
                    _this.squares[i + _this.width].innerHTML = newColumn[1];
                    _this.squares[i + _this.width * 2].innerHTML = newColumn[2];
                    _this.squares[i + _this.width * 3].innerHTML = newColumn[3];
                };
                var moved = false;
                for(var i = 0; i < 4; i++)_loop(i);
                this.didMove = moved;
            }
        },
        {
            key: "getScore",
            value: function getScore() {
                return this.score;
            }
        },
        {
            key: "getState",
            value: function getState() {
                return this.board.map(function(row) {
                    return (0, $227c6742e0ff6f82$export$71511d61b312f219)(row);
                });
            }
        },
        {
            key: "getStatus",
            value: function getStatus() {
                return this.initialState;
            }
        },
        {
            key: "start",
            value: function start() {
                this.initialState = "playing";
                this.generate(true);
                this.generate(true);
                this.addColors();
            }
        },
        {
            key: "restart",
            value: function restart() {
                this.beforeStart();
                this.initialState = "idle";
                this.score = 0;
                $3d28d7f1aac198f5$var$score.innerHTML = 0;
            }
        },
        {
            key: "combineRow",
            value: function combineRow(move) {
                for(var i = 0; i < 15; i++)if (this.squares[i].innerHTML !== "0" && this.squares[i].innerHTML === this.squares[i + 1].innerHTML && i % 4 !== 3) {
                    var combined = parseInt(this.squares[i].innerHTML) + parseInt(this.squares[i + 1].innerHTML);
                    this.squares[i].innerHTML = combined;
                    this.squares[i + 1].innerHTML = 0;
                    this.score += combined;
                    $3d28d7f1aac198f5$var$score.innerHTML = this.score;
                    this.didMove = true;
                }
                var previousDidMove = this.didMove;
                this.checkIfWin();
                this.checkIfLose();
                if (move === "right") this.moveRight();
                if (move === "left") this.moveLeft();
                if (previousDidMove !== this.didMove) this.didMove = previousDidMove;
            }
        },
        {
            key: "combineColumn",
            value: function combineColumn(move) {
                for(var i = 0; i < 12; i++)if (this.squares[i].innerHTML !== "0" && this.squares[i].innerHTML === this.squares[i + this.width].innerHTML) {
                    var combined = parseInt(this.squares[i].innerHTML) + parseInt(this.squares[i + this.width].innerHTML);
                    this.squares[i].innerHTML = combined;
                    this.squares[i + this.width].innerHTML = 0;
                    this.score += combined;
                    $3d28d7f1aac198f5$var$score.innerHTML = this.score;
                    this.didMove = true;
                }
                var previousDidMove = this.didMove;
                this.checkIfWin();
                this.checkIfLose();
                if (move === "up") this.moveUp();
                if (move === "down") this.moveDown();
                if (previousDidMove !== this.didMove) this.didMove = previousDidMove;
            }
        }
    ]);
    return Game;
}();
$3d28d7f1aac198f5$exports = $3d28d7f1aac198f5$var$Game;


var $197cd56b15c33885$var$game = new $3d28d7f1aac198f5$exports("idle");
var $197cd56b15c33885$var$startButton = document.querySelector(".start");
var $197cd56b15c33885$var$winMessage = document.querySelector(".message-win");
var $197cd56b15c33885$var$loseMessage = document.querySelector(".message-lose");
var $197cd56b15c33885$var$startMessage = document.querySelector(".message-start");
$197cd56b15c33885$var$startButton.addEventListener("click", function(e) {
    return $197cd56b15c33885$var$StartRestart(e);
});
document.addEventListener("DOMContentLoaded", function() {
    $197cd56b15c33885$var$game.beforeStart();
});
function $197cd56b15c33885$var$StartRestart(e) {
    if (e.target.innerHTML === "Start") {
        $197cd56b15c33885$var$startMessage.classList.add("hidden");
        e.target.innerHTML = "Restart";
        e.target.classList.remove("start");
        e.target.classList.add("restart");
        $197cd56b15c33885$var$game.start();
    } else {
        $197cd56b15c33885$var$startMessage.classList.remove("hidden");
        e.target.innerHTML = "Start";
        e.target.classList.remove("restart");
        e.target.classList.add("start");
        $197cd56b15c33885$var$game.restart();
        $197cd56b15c33885$var$clearErrors();
    }
}
function $197cd56b15c33885$var$checkStatus() {
    if ($197cd56b15c33885$var$game.getStatus() === "win") $197cd56b15c33885$var$winMessage.classList.remove("hidden");
    if ($197cd56b15c33885$var$game.getStatus() === "lose") $197cd56b15c33885$var$loseMessage.classList.remove("hidden");
}
function $197cd56b15c33885$var$clearErrors() {
    $197cd56b15c33885$var$winMessage.classList.add("hidden");
    $197cd56b15c33885$var$loseMessage.classList.add("hidden");
}
var $197cd56b15c33885$var$allowedKeys = [
    "ArrowRight",
    "ArrowLeft",
    "ArrowUp",
    "ArrowDown"
];
var $197cd56b15c33885$export$b5cde1de278b4330 = function() {
    var _ref = (0, $554ed4b40b13e16f$export$71511d61b312f219)(function(e) {
        return (0, $fc5e3658b603cf39$export$67ebef60e6f28a6)(this, function(_state) {
            if ($197cd56b15c33885$var$allowedKeys.includes(e.key) && !$197cd56b15c33885$var$startMessage.classList.contains("hidden")) {
                $197cd56b15c33885$var$startMessage.classList.add("hidden");
                $197cd56b15c33885$var$startButton.innerHTML = "Restart";
                $197cd56b15c33885$var$startButton.classList.remove("start");
                $197cd56b15c33885$var$startButton.classList.add("restart");
                $197cd56b15c33885$var$game.start();
                return [
                    2
                ];
            }
            if (e.key === "ArrowRight") {
                $197cd56b15c33885$var$game.didMove = false;
                $197cd56b15c33885$var$game.moveRight();
                $197cd56b15c33885$var$game.combineRow("right");
                $197cd56b15c33885$var$game.generate();
                $197cd56b15c33885$var$game.didMove = false;
                $197cd56b15c33885$var$game.addColors();
                $197cd56b15c33885$var$checkStatus();
            }
            if (e.key === "ArrowLeft") {
                $197cd56b15c33885$var$game.didMove = false;
                $197cd56b15c33885$var$game.moveLeft();
                $197cd56b15c33885$var$game.combineRow("left");
                $197cd56b15c33885$var$game.generate();
                $197cd56b15c33885$var$game.didMove = false;
                $197cd56b15c33885$var$game.addColors();
                $197cd56b15c33885$var$checkStatus();
            }
            if (e.key === "ArrowUp") {
                $197cd56b15c33885$var$game.didMove = false;
                $197cd56b15c33885$var$game.moveUp();
                $197cd56b15c33885$var$game.combineColumn("up");
                $197cd56b15c33885$var$game.generate();
                $197cd56b15c33885$var$game.didMove = false;
                $197cd56b15c33885$var$game.addColors();
                $197cd56b15c33885$var$checkStatus();
            }
            if (e.key === "ArrowDown") {
                $197cd56b15c33885$var$game.didMove = false;
                $197cd56b15c33885$var$game.moveDown();
                $197cd56b15c33885$var$game.combineColumn("down");
                $197cd56b15c33885$var$game.generate();
                $197cd56b15c33885$var$game.didMove = false;
                $197cd56b15c33885$var$game.addColors();
                $197cd56b15c33885$var$checkStatus();
            }
            return [
                2
            ];
        });
    });
    return function control(e) {
        return _ref.apply(this, arguments);
    };
}();
document.addEventListener("keydown", $197cd56b15c33885$export$b5cde1de278b4330);

})();
//# sourceMappingURL=index.2c0dd1e4.js.map
